import {
  EventStatusEnum,
  NON_COMPLETE_STATUSES,
  COMPLETE_STATUSES,
} from "./eventStatus";

export enum TimeFilterEnum {
  PAST = "PAST",
  UPCOMING = "UPCOMING",
}

export {
  EventStatusEnum,
  NON_COMPLETE_STATUSES,
  COMPLETE_STATUSES,
  ALL_STATUSES,
  statusLabels,
  statusColors,
} from "./eventStatus";

export interface EventFilter {
  statuses?: EventStatusEnum[];
  startDateFrom?: string;
  startDateTo?: string;
  endDateFrom?: string;
  endDateTo?: string;
  clientId?: string;
  contactName?: string;
  companyName?: string;
  hasVacancies?: boolean;
  timeFilter?: TimeFilterEnum;
}

export interface EventFilterConfig {
  allowedStatuses: EventStatusEnum[];
  defaultSelectedStatuses?: EventStatusEnum[];
  showStatusFilter: boolean;
  showTimeFilter: boolean;
  showVacancyFilter: boolean;
  showDateFilters: boolean;
  showClientFilters: boolean;
  showCompanyNameFilter: boolean;
}

const NON_COMPLETE_EXCEPT_CANCELLED = NON_COMPLETE_STATUSES.filter(
  (status) => status !== EventStatusEnum.CANCELLED,
);

export const MANAGE_BIDS_CONFIG: EventFilterConfig = {
  allowedStatuses: NON_COMPLETE_STATUSES,
  defaultSelectedStatuses: [
    EventStatusEnum.NEW,
    EventStatusEnum.CONTACTED,
    EventStatusEnum.BIDSENT,
    EventStatusEnum.AWAITINGPAYMENT,
    EventStatusEnum.FOLLOWEDUP,
  ],
  showStatusFilter: true,
  showTimeFilter: false,
  showVacancyFilter: false,
  showDateFilters: false,
  showClientFilters: true,
  showCompanyNameFilter: true,
};

export const MANAGE_EVENTS_CONFIG: EventFilterConfig = {
  allowedStatuses: COMPLETE_STATUSES,
  defaultSelectedStatuses: COMPLETE_STATUSES,
  showStatusFilter: false,
  showTimeFilter: true,
  showVacancyFilter: true,
  showDateFilters: true,
  showClientFilters: true,
  showCompanyNameFilter: true,
};
